<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="onCancel()"
        ><ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>OTP Verification</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <div id="recaptcha-container"></div>
  <ion-item color="lightmimbo" lines="none" class="number">
    <ion-text>{{ phoneNumber }}</ion-text>
    <ion-button (click)="sendOtp()" size="default" [disabled]="isSent"
      ><ion-label>
        <ion-spinner *ngIf="resendLoading"></ion-spinner> Send OTP</ion-label
      ></ion-button
    >
  </ion-item>
  <ion-item color="lightmimbo">
    <ion-label position="floating">Enter OTP</ion-label>
    <ion-input [(ngModel)]="otp" type="text"></ion-input>
  </ion-item>
  <ion-item lines="none" class="" color="lightmimbo">
    <ion-button (click)="verifyOtp()" size="default" class="OTP-button"
      ><ion-label
        ><ion-spinner *ngIf="isVerifying"></ion-spinner>Verify OTP</ion-label
      ></ion-button
    >
  </ion-item>
  <ion-item lines="none" class="" color="lightmimbo">
    <ion-button
      (click)="sendOtp()"
      size="default"
      class="OTP-button"
      *ngIf="canResend"
      ><ion-label>
        <ion-spinner *ngIf="resendLoading"></ion-spinner> Re-Send OTP</ion-label
      ></ion-button
    >
    <ion-text color="danger" style="margin: auto" *ngIf="!canResend">{{
      timerText
    }}</ion-text>
  </ion-item>
</ion-content>
